import imgCheyThavy from '~/assets/images/teachers/prof_chhey-thavy.png';
import imgLongSarin from '~/assets/images/teachers/prof_long-sarin.png';
import imgTeangBang from '~/assets/images/teachers/prof_teing-bang.png';
import imgMeasPirun from '~/assets/images/teachers/prof_MeasPirun.png';
import imgNeangBo from '~/assets/images/teachers/prof_NeangBo.png';
import imgThouPorn from '~/assets/images/teachers/prof_ThouPorn.png';

export interface LecturerSource {
  initials: string;
  bgColor: string;
  image: string;
  name: {
    en: string;
    kh: string;
  };
  subject: {
    en: string;
    kh: string;
  };
}

export const LECTURERS_DATA: LecturerSource[] = [
  {
    initials: 'ជថ',
    bgColor: 'bg-gradient-to-tr from-emerald-500 to-teal-600',
    image: imgCheyThavy,
    name: { en: 'Professor Chey Thavy', kh: 'លោកសាស្ត្រាចារ្យ ជ័យ ថាវី' },
    subject: { en: 'Chemistry', kh: 'ផ្នែកគីមីវិទ្យា' },
  },
  {
    initials: 'នប',
    bgColor: 'bg-gradient-to-tr from-blue-500 to-indigo-600',
    image: imgNeangBo,
    name: { en: 'Professor Neang Bo', kh: 'លោកសាស្ត្រាចារ្យ នាង បូ' },
    subject: { en: 'Mathematics', kh: 'ផ្នែកគណិតវិទ្យា' },
  },
  {
    initials: 'ឡស',
    bgColor: 'bg-gradient-to-tr from-rose-500 to-orange-600',
    image: imgLongSarin,
    name: { en: 'Professor Long Sarin', kh: 'លោកសាស្ត្រាចារ្យ ឡុង សារិន' },
    subject: { en: 'Khmer Literature', kh: 'ផ្នែកអក្សរសាស្ត្រខ្មែរ' },
  },
  {
    initials: 'ទប',
    bgColor: 'bg-gradient-to-tr from-purple-500 to-indigo-600',
    image: imgTeangBang,
    name: { en: 'Professor Teang Pang', kh: 'លោកសាស្ត្រាចារ្យ ទាង ប៉ាង' },
    subject: { en: 'Physics', kh: 'ផ្នែករូបវិទ្យា' },
  },
  {
    initials: 'ធភ',
    bgColor: 'bg-gradient-to-tr from-amber-500 to-yellow-600',
    image: imgThouPorn,
    name: { en: 'Professor Thuo Phorn', kh: 'លោកសាស្ត្រាចារ្យ ធូ ភន' },
    subject: { en: 'Biology', kh: 'ផ្នែកជីវវិទ្យា' },
  },
  {
    initials: 'មភ',
    bgColor: 'bg-gradient-to-tr from-pink-500 to-rose-600',
    image: imgMeasPirun,
    name: { en: 'Professor Meas Phirun', kh: 'លោកសាស្ត្រាចារ្យ មាស ភិរុណ' },
    subject: { en: 'History', kh: 'ផ្នែកប្រវត្តិវិទ្យា' },
  },
];

export interface Lecturer {
  id: number;
  name: string;
  subject: string;
  initials: string;
  bgColor: string;
  image: string;
  prefix: string;
  nameOnly: string;
}

export const getLecturers = (locale: string): Lecturer[] => {
  const isKh = locale === 'kh';
  return LECTURERS_DATA.map((item, index) => {
    const fullName = isKh ? item.name.kh : item.name.en;
    const prefixes = ['Professor', 'លោកសាស្ត្រាចារ្យ', 'សាស្ត្រាចារ្យ'];
    let prefix = '';
    let nameOnly = fullName;

    for (const p of prefixes) {
      if (fullName.startsWith(p)) {
        prefix = p;
        nameOnly = fullName.slice(p.length).trim();
        break;
      }
    }

    return {
      id: index + 1,
      name: fullName,
      subject: isKh ? item.subject.kh : item.subject.en,
      initials: item.initials,
      bgColor: item.bgColor,
      image: item.image,
      prefix,
      nameOnly,
    };
  });
};
